import React from 'react';
import { useState } from "react";
import Page from '../../components/Page';
import {
    Box,
    Typography,
    Button,
    Modal,
} from '@mui/material';
import {
    DataGrid,
} from '@mui/x-data-grid';
import { Check, PlusSquare } from 'react-feather';
import CreateUser from '../users/CreateUser';
import CheckUser from '../users/CheckUser';
import UserRoleChange from '../users/UserRoleChange';
import EmployeeRoleCell from '../users/EmployeeRoleCell';
import { createEmployeeStatusColumn, EmployeeDataGridToolbar } from '../users/employeeTableColumns';
import "../users/Users.css";
import { useDeactivateEmployee, useSelectedCompanyUsers } from '../../hooks/useCompanyUsers';
import { useAdminCompany } from '../../context/AdminCompanyContext';

const CompanyUserView = () => {
    const [open, setOpen] = React.useState(false);
    const [check, setCheck] = React.useState(false);

    const { companyData } = useAdminCompany();
    const { data: users = [] } = useSelectedCompanyUsers({
        companyId: companyData?.id,
        enabled: Boolean(companyData?.id),
    });

    const [open1, setOpen1] = React.useState(false);
    const handleOpen1 = () => setOpen1(true);
    const handleClose1 = () => setOpen1(false);
    const deactivateEmployeeMutation = useDeactivateEmployee();
    const [rowItem, setRowItem] = useState();

    function editRole(cellValues) { // hadles the double click to bring up modal to edit crop amount
        setRowItem({
            userId: cellValues.row.id,
            userRole: cellValues.row.userRole,
        });
        handleOpen1();
    };

    function deactivateEmployee(cellValues){
        setRowItem({
            userId: cellValues.row.id,
        });
        deactivateEmployeeMutation.mutate({Id: cellValues.row.id, CompanyId: companyData.id});
    };

    const columns = [
        { field: 'userName', headerName: 'Username', width: 200, headerClassName: 'header' },
        { field: 'email', headerName: 'Email', width: 300, headerClassName: 'header' },
        { field: 'firstName', headerName: 'First Name', width: 150, headerClassName: 'header' },
        { field: 'lastName', headerName: 'Last Name', width: 150, headerClassName: 'header' },
        { field: 'userRole', headerName: 'Role', width: 250, headerClassName: 'header',
            renderCell: (cellValues) => (
                <EmployeeRoleCell cellValues={cellValues} onEdit={editRole} />
            )
        },
        { field: 'activeAppUserDate', headerName: 'Activity', width: 150, headerClassName: 'header',
            renderCell: (cellValues)=>{
                let activeAppUserDate = new Date(cellValues.row.activeAppUserDate);
                const options = {
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                };
                let dateOfLastPurchase = new Date(cellValues.row.dateOfLastPurchase);

                function dateDiffInDays(a, b) {
                    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
                    // Discard the time and time-zone information.
                    const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
                    const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

                    return Math.floor((utc2 - utc1) / _MS_PER_DAY);
                  }

                  // test it
                  const a = activeAppUserDate, b = new Date(), activeAppUserDateDifference = dateDiffInDays(a, b);

                  const c = dateOfLastPurchase, d = new Date(), dateOfLastPurchaseDifference = dateDiffInDays(c, d);

                if(!cellValues.row.activeAppUserDate){
                    return(
                        <div>
                            N/A
                        </div>
                    )
                } else if (dateOfLastPurchaseDifference > 90 && cellValues.row.hasUnexpiredLicense === false && activeAppUserDateDifference < 90){
                    return <span style={{color:'red'}}>Locked: {dateOfLastPurchaseDifference.toLocaleString("en-US",options)} days</span>
                } else if((activeAppUserDateDifference <= 80)){
                    return <span style={{color:'green'}}>Active: {activeAppUserDate.toLocaleString("en-US",options)}</span>
                } else if(activeAppUserDateDifference > 80 && activeAppUserDateDifference <= 90){
                    return <span style={{color:'orange'}}>Active: {activeAppUserDate.toLocaleString("en-US",options)}</span>
                } else if(activeAppUserDateDifference > 90){
                    return <span style={{color:'gray'}}>Inactive: {activeAppUserDate.toLocaleString("en-US",options)}</span>
                }
            }
        },
        createEmployeeStatusColumn(deactivateEmployee),
    ];

    const handleOpen = () => setOpen(!open);
    const handleCheck = () => setCheck(!check);

    return (
        <div>
            <Box p={3} sx={{ '& .header': { backgroundColor: '#e2e2e2' } }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', flexDirection:'column' }}>
                    <Typography variant='h3' textAlign='left' p={2}>
                        Employees
                    </Typography>
                    <Button
                        variant='text'
                        color='warning'
                        startIcon={<PlusSquare/>}
                        onClick={handleOpen}
                    >
                        New User
                    </Button>
                    <Modal open={open} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <CreateUser type={1} close={handleOpen}/>
                    </Modal>
                    <Modal open={check} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <CheckUser close={handleCheck}/>
                    </Modal>
                </Box>
                <DataGrid
                    columns={columns}
                    rows={users}
                    style={{textAlign:'left', height:'70vh'}}
                    components={{
                        Toolbar: EmployeeDataGridToolbar,
                    }}
                />
                <Modal
                    open={open1}
                    onClose={handleClose1}
                    className="employeeStatusModal"
                >
                <UserRoleChange item={rowItem} handleClose1={handleClose1} page={1} companyData={companyData}/>
                </Modal>
            </Box>
        </div>
    )
};

export default CompanyUserView;